export const GLOBAL_CHAT_CONSTANTS = {
  CHAT_WIDTH: 360, // pixels
  CHAT_HEIGHT: 520, // pixels
  MESSAGES_SIDEBAR_HEIGHT: 740, // pixels
  MINIMIZED_CHAT_WIDTH: 240, // pixels
  MINIMIZED_CHAT_HEIGHT: 44, // pixels
  MAX_VISIBLE_CHATS: 2,
  COLLAPSED_HEIGHT: 40, // pixels
  SPACING_BETWEEN_CHATS: 16, // pixels
} as const;
